export default __webpack_public_path__ + "static/media/Pslogo.015096bf.png";